import { render } from "./BaseCard.vue?vue&type=template&id=5ddcb91c&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=5ddcb91c&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddcb91c"]])

export default __exports__